import React, { useState } from 'react';
import { ChevronDownIcon, ShieldIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-800 last:border-b-0" data-id="element-73">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-4 text-left font-medium focus:outline-none" data-id="element-74">
        <span data-id="element-75">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-yellow-500 transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-76" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-4' : 'max-h-0'}`} data-id="element-77">
        <p className="text-gray-400" data-id="element-78">{answer}</p>
      </div>
    </div>;
};
export const FAQ: React.FC = () => {
  const faqs = [{
    question: '¿Es este un producto oficial de Cristiano Ronaldo?',
    answer: 'No, este es un producto fan-made creado con fines de apreciación e inspiración. No está afiliado ni patrocinado por Cristiano Ronaldo ni por ninguna entidad asociada a él.'
  }, {
    question: '¿Qué tipo de imágenes incluye el ebook?',
    answer: 'El ebook incluye ilustraciones originales estilizadas, arte geométrico y diseños conceptuales inspirados en momentos icónicos. No utilizamos imágenes oficiales con derechos de autor.'
  }, {
    question: '¿Puedo obtener un reembolso si no me gusta?',
    answer: 'Al ser un producto digital de edición limitada, no ofrecemos reembolsos una vez completada la compra. Te recomendamos revisar toda la información antes de realizar tu pedido.'
  }, {
    question: '¿Cómo recibo mi ebook después de la compra?',
    answer: 'Inmediatamente después de completar tu compra, recibirás un enlace de descarga en tu correo electrónico. También podrás acceder a tu contenido desde tu área de cliente.'
  }, {
    question: '¿En qué formatos está disponible el ebook?',
    answer: 'El ebook está disponible en formato PDF optimizado para visualización en cualquier dispositivo (ordenador, tablet o móvil). Los bonos se entregan en formatos compatibles según su tipo.'
  }, {
    question: '¿Realmente es una edición limitada?',
    answer: 'Sí, solo produciremos 200 copias en esta tirada. Cada copia incluye un certificado de edición limitada con un número único.'
  }];
  return <section className="py-20" data-id="element-79">
      <div className="max-w-3xl mx-auto" data-id="element-80">
        <div className="text-center mb-12" data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-82">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-gray-300" data-id="element-83">
            Todo lo que necesitas saber sobre este producto digital
            coleccionable.
          </p>
        </div>
        <div className="bg-gradient-to-b from-gray-900 to-black border border-yellow-600/20 rounded-xl p-6" data-id="element-84">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-85" />)}
        </div>
        <div className="mt-12 p-6 border border-yellow-600/30 rounded-lg bg-yellow-600/5" data-id="element-86">
          <h3 className="font-bold text-xl mb-4 text-center flex items-center justify-center" data-id="element-87">
            <ShieldIcon className="w-6 h-6 text-yellow-500 mr-2" data-id="element-88" /> AVISO LEGAL
          </h3>
          <p className="text-sm text-gray-400 mb-4" data-id="element-89">
            Esta es una obra fan-made no oficial con fines de apreciación e
            inspiración. No está afiliada ni patrocinada por Cristiano Ronaldo
            ni por ninguna entidad asociada. Todas las imágenes son originales o
            estilizadas, sin infringir derechos de imagen. Producto 100% digital
            y no reembolsable.
          </p>
          <p className="text-sm text-gray-400" data-id="element-90">
            <strong data-id="element-91">Nota sobre las imágenes:</strong> Las ilustraciones
            utilizadas son interpretaciones artísticas estilizadas que sugieren
            la figura de Cristiano Ronaldo a través de siluetas, efectos
            geométricos, contornos dorados y arte abstracto, sin utilizar
            fotografías oficiales, logos, uniformes o material con derechos de
            autor.
          </p>
        </div>
      </div>
    </section>;
};